export const BANNER_EVENTS = {
  BANNER_VIEWED: 'App Store Banner Viewed',
  BANNER_CLICKED: 'App Store Banner Clicked',
  GROUP_ASSIGNED: 'Experiment App Store Banner Group Assigned',
};
